module.exports = __webpack_public_path__ + "static/media/play-runaway.ffd52525.ogg";